import { MatchListStore } from "./matchList/MatchListStore";

export class RootStore {
  matchListStore: MatchListStore;

  constructor() {
    this.matchListStore = new MatchListStore(this);
  }
}

// Create a single instance of the store
const rootStore = new RootStore();
export default rootStore;
